import React from 'react';
import classnames from 'classnames';
import Icon from 'Shared/Icon';
import * as styles from './toggle.scss';
export default (type) => (props) => {
    const inputProps = Object.assign({}, props, {
        className: styles.input,
    });
    delete inputProps.children;
    delete inputProps.semiChecked;
    delete inputProps.appearance;
    return (React.createElement("label", { className: classnames(styles.base, props.className, {
            [styles.disabled]: props.disabled,
            [styles.semiChecked]: props.semiChecked,
            [styles.light]: props.appearance === 'light',
            [styles.toggle]: props.appearance === 'toggle',
        }) },
        React.createElement("input", Object.assign({ type: type }, inputProps)),
        React.createElement("span", { className: styles.label }, props.appearance !== 'toggle' && (React.createElement(React.Fragment, null,
            React.createElement(Icon, { name: "check", className: styles.checkmark }),
            React.createElement("span", { className: styles.toggleTextContent }, props.children))))));
};
